/**
 * CAT Accident Type Chip Component
 *
 * Displays the accident type of a CAT with appropriate color.
 */

import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { AccidentType, ACCIDENT_TYPE_LABELS, ACCIDENT_TYPE_COLORS } from '../../../types/cat';

interface CatAccidentTypeChipProps extends Omit<ChipProps, 'color' | 'label'> {
  type: AccidentType;
}

export const CatAccidentTypeChip: React.FC<CatAccidentTypeChipProps> = ({ type, ...props }) => {
  return (
    <Chip
      label={ACCIDENT_TYPE_LABELS[type] || type}
      color={ACCIDENT_TYPE_COLORS[type] || 'default'}
      size="small"
      {...props}
    />
  );
};

export default CatAccidentTypeChip;
